export const MESSAGES = {
	notCurrentUser: "Ocurrio un error al ingresar a la plataforma",
	errorRole: "No cuenta con los permisos para acceder a la plataforma.",
	emailUnverified: "Le enviamos un correo para validar su cuenta.",
	resetPassword: "Le enviamos un correo para resetear su contraseña",
};

export const VALIDATE_INPUTS = {
	incomplete: "Este campo es obligatorio",
};

export const USER_ROLE = "recruiter";

export const STATES = {
	inProgress: "Por evaluar",
	accepted: "Aceptado",
	refused: "Rechazado",
};

export const TIME_OUT = 10000;

export const WORKFAST_IMAGE_WHITE =
	"https://firebasestorage.googleapis.com/v0/b/workfast-f9c03.appspot.com/o/workfast%2Fworkfast-logo-white.jpg?alt=media&token=cf857536-c755-4159-ad04-a83d3e21bbd7";
